// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCIurS6yVCQgj9Qox-xpCX1pqejw5EXWS8",
  authDomain: "affiliatemate-1b384.firebaseapp.com",
  databaseURL: "https://affiliatemate-1b384-default-rtdb.firebaseio.com",
  projectId: "affiliatemate-1b384",
  storageBucket: "affiliatemate-1b384.firebasestorage.app",
  messagingSenderId: "240544915829",
  appId: "1:240544915829:web:87a51ed978c62fcd0e333c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
